
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"1em","height":"1em","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","d":"M0 0h16v16H0z"}}),_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M12.5 9.75A2.75 2.75 0 009.75 7H4.56l2.22 2.22a.75.75 0 11-1.06 1.06l-3.5-3.5a.75.75 0 010-1.06l3.5-3.5a.75.75 0 011.06 1.06L4.56 5.5h5.19a4.25 4.25 0 010 8.5h-1a.75.75 0 010-1.5h1a2.75 2.75 0 002.75-2.75","clip-rule":"evenodd"}})])
          )
        }
      }
    